import { render, staticRenderFns } from "./ListContracts.vue?vue&type=template&id=2b1db758&scoped=true&"
import script from "./ListContracts.vue?vue&type=script&lang=ts&"
export * from "./ListContracts.vue?vue&type=script&lang=ts&"
import style0 from "./ListContracts.vue?vue&type=style&index=0&id=2b1db758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1db758",
  null
  
)

export default component.exports